import { useAuth } from 'common/hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';

export function NoRequireAuth({ children }: { children: JSX.Element }) {
  const auth = useAuth();
  const location = useLocation();
  console.log(location);
  // alert('aqui NoRequireAuth');
  // if (localStorage.getItem('application.auth.token')) {
  if (auth?.isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to='/' state={{ from: location }} />;
  }

  return children;
}
